import { apiRequest } from '../lib/api-client';

/** Custom fields: the same field on every record, which is why it is configuration (§33). */

export interface CustomFieldEntry {
  id: string;
  entity_type: string;
  key: string;
  label: string;
  field_type: string;
  choices: string[];
  required: boolean;
  position: number;
  is_active: boolean;
}

export function listCustomFields(entityType: string): Promise<{ fields: CustomFieldEntry[] }> {
  return apiRequest(`/v1/catalogues/custom-fields?entityType=${entityType}`);
}

export function createCustomField(input: {
  entityType: string;
  label: string;
  key?: string;
  fieldType: string;
  choices?: string[];
  required?: boolean;
}): Promise<CustomFieldEntry> {
  return apiRequest('/v1/catalogues/custom-fields', { method: 'POST', body: input });
}

export function updateCustomField(
  id: string,
  input: {
    entityType: string;
    label?: string;
    choices?: string[];
    required?: boolean;
    isActive?: boolean;
  },
): Promise<CustomFieldEntry> {
  return apiRequest(`/v1/catalogues/custom-fields/${id}`, { method: 'PATCH', body: input });
}
